import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme, props) {
  var wrapperStyles = {
    width: '100%',
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  };
  var errorBorderStyles = {
    margin: componentTheme.errorBorderMargin,
    padding: componentTheme.errorBorderPadding,
    border: "solid 1px ".concat(componentTheme.errorBorderColor),
    borderRadius: componentTheme.errorBorderBorderRadius
  };
  return {
    titleEditWrapper: {
      position: 'relative',
      width: '100%',
      height: '5rem',
      boxSizing: 'border-box',
      paddingLeft: componentTheme.titleEditWrapperLeftPadding,
      paddingRight: componentTheme.titleEditWrapperRightPadding,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    titleEditInput: _objectSpread({
      fontFamily: componentTheme.titleEditInputFontFamily,
      fontSize: componentTheme.titleEditInputFontSize
    }, props.errorsAreShowing && props.errors.size > 0 && errorBorderStyles),
    inputWrapper: wrapperStyles,
    errorsWrapper: wrapperStyles
  };
};
export default generateStyle;